import React, { Component } from 'react'
import styles from './styles.css'
import { IoIosRadioButtonOn } from 'react-icons/io';
import { MdArrowBack } from 'react-icons/md'

class Images extends Component {
    constructor(props) {
        super(props)

        this.cameraVideo = React.createRef()
        this.cameraImage = React.createRef()
        this.fileInput = React.createRef()
        this.state = {
            isCameraOn: false,
            stream: undefined,
        }
    }

    turnOnCamera = () => {
    // Use native camera UI if available (mobile)
    if (this.fileInput.current) {
      this.fileInput.current.click();
    } else {
      // Fallback to custom camera
        if (navigator.mediaDevices) {
            navigator.mediaDevices
                .getUserMedia(this.props.constraints)
                .then(this.handleSuccess)
                .catch(this.handleError)
        } else {
            alert('Camera not supported by browser')
        }
    }
  }

  compressAndCaptureImage = (canvas) => {
    canvas.toBlob(
      (blob) => {
        const { size } = blob;
        const sizeInMB = size / (1024 * 1024);
        const { captureImage } = this.props;
        if (sizeInMB < 1) {
          captureImage(canvas.toDataURL("image/jpeg", 0.8));
        } else if (sizeInMB > 1 && sizeInMB < 2) {
          captureImage(canvas.toDataURL("image/jpeg", 0.6));
        } else if (sizeInMB > 2) {
          captureImage(canvas.toDataURL("image/jpeg", 0.4));
        }
        canvas.remove();
      },
      "image/jpeg",
      1
    );
  };

    handleSuccess = stream => {
        this.stream = stream
        this.setState({
            isCameraOn: true,
            stream: stream
        })
        this.props.cameraStateChange(true)
        if (window.URL) {
            this.cameraVideo.srcObject = stream
        } else {
            this.cameraVideo.src = stream
        }
    }

    handleFileChange = (e) => {
      const file = e.target.files[0];
      const { captureImage } = this.props;
      if (file) {
        if (file.type.startsWith('video/')) {
          alert('Please upload a photo, not a video.');
          e.target.value = "";
          return;
        }
        if (file.size > 1024 * 1024) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const imageDataUrl = event.target.result;
            const img = new Image();
            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);
              this.compressAndCaptureImage(canvas);
            };
            img.src = imageDataUrl;
          };
          reader.readAsDataURL(file);
        } else {
          const reader = new FileReader();
          reader.onload = (event) => {
            captureImage(event.target.result);
          };
          reader.readAsDataURL(file);
        }
      }
      // Reset input so same file can be selected again
      e.target.value = "";
    };

    takeSnapshot = () => {
        let context;
        let width = this.cameraVideo.offsetWidth
            , height = this.cameraVideo.offsetHeight;

        let canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        context = canvas.getContext('2d');
        context.drawImage(this.cameraVideo, 0, 0, width, height);
        this.stream && this.stream.getTracks().forEach(stream => stream.stop())
        this.setState({
            isCameraOn: false
        })
        this.props.cameraStateChange(false)
        this.compressAndCaptureImage(canvas);
    }

    goBack = () => {
        this.stream && this.stream.getTracks().forEach(stream => stream.stop())
        this.setState({
            isCameraOn: false
        })
        this.props.cameraStateChange(false)
    }

    render() {
        const { url, content, title, subtitle, frame, subFrame, frameHeight } = this.props
        const { isCameraOn } = this.state
        return (
            <div>
                {
                    isCameraOn ?
                        <video
                            id="cameraVideo"
                            className={styles.video}
                            ref={el => (this.cameraVideo = el)}
                            playsInline
                            autoPlay
                            muted
                        /> :
                        null
                }
                {
                    isCameraOn ?
                        <div className={styles.overlay}>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }} onClick={this.goBack}>
                                <div style={{ marginRight: 'auto' }}><MdArrowBack color={'#fff'} size={40} /></div>
                                <div style={{ marginRight: 'auto', marginLeft: 10, textAlign: 'center' }}>
                                    <h2 style={{ color: '#fff', margin: 0 }}>{title}</h2>
                                    <h6 style={{ color: '#fff', margin: 0 }}>{subtitle}</h6>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '100%', height: frameHeight, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src={frame} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div style={{ width: '85%', height: 200, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <img src={subFrame} />
                                </div>
                            </div>
                            <div className={styles.captureButtonWrapper} onClick={this.takeSnapshot}>
                                <IoIosRadioButtonOn color={'#fff'} size={60} />
                            </div>
                        </div>
                        : null
                }
                {/* <img ref={el => (this.cameraImage = el)} className={styles.image}/> */}
                <input
                  type="file"
                  capture="environment"
                  accept="image/*"
                  ref={this.fileInput}
                  onChange={this.handleFileChange}
                  style={{ display: "none" }}
                />
                <div style={{ width: '100%' }} onClick={this.turnOnCamera}>
                    {content}
                </div>
            </div>
        )
    }
}

export default Images
